import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-gray-600 hover:text-black mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </Link>
          
          <h1 className="font-nouvel text-4xl font-bold mb-8">Impressum</h1>
          
          <div className="prose prose-lg max-w-none font-read">
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">Angaben gemäß § 5 TMG</h2>
            <p>
              <strong>Auto Thurm</strong><br />
              Inhaber: Tobias Thurm<br />
              Wildenreuth A 55<br />
              92681 Erbendorf<br />
              Deutschland
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">Kontakt</h2>
            <p>
              Telefon: 09682 722<br />
              E-Mail: info@auto-thurm.de
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">Vertreten durch</h2>
            <p>
              Inhaber: Tobias Thurm
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">Registereintrag</h2>
            <p>
              <em>Falls im Handelsregister eingetragen:</em><br />
              Registergericht: [Amtsgericht]<br />
              Registernummer: [HRB/HRA Nummer]
            </p>
            <p className="text-sm text-gray-500 mt-2">
              (Nur erforderlich bei eingetragenen Unternehmen - bei Einzelunternehmen ohne HR-Eintrag kann dieser Abschnitt entfernt werden)
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">Umsatzsteuer-ID</h2>
            <p>
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              [DE XXXXXXXXX]
            </p>
            <p className="text-sm text-gray-500 mt-2">
              (Falls vorhanden - ansonsten kann dieser Abschnitt entfernt werden)
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">Berufsbezeichnung und berufsrechtliche Regelungen</h2>
            <p>
              Berufsbezeichnung: Kraftfahrzeughändler / Kfz-Werkstatt<br />
              Zuständige Kammer: IHK für Oberfranken Bayreuth
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#EFDF00] hover:underline ml-1">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">Haftung für Inhalte</h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
              nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
              Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
              Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
              Tätigkeit hinweisen.
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">Haftung für Links</h2>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen 
              Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
              Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der 
              Seiten verantwortlich.
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">Urheberrecht</h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
              dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
              der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
              Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">Webentwicklung</h2>
            <p>
              Diese Website wurde entwickelt von:<br /><br />
              <strong>Emergent Labs</strong><br />
              <a 
                href="https://emergentagent.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#EFDF00] hover:underline"
              >
                www.emergentagent.com
              </a>
            </p>
            
            <div className="mt-12 p-4 bg-yellow-50 border-l-4 border-[#EFDF00]">
              <p className="text-sm text-gray-600">
                <strong>Noch zu ergänzen:</strong>
              </p>
              <ul className="text-sm text-gray-600 list-disc ml-4 mt-2">
                <li>Umsatzsteuer-ID (falls vorhanden)</li>
                <li>Handelsregisternummer (falls im HR eingetragen)</li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ImpressumPage;
